import React, { useState, useEffect } from "react";
import ServiceHeader from "./ServiceHeader";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { patientFeedBackData } from "../../thirdUtils/constant";
import quotesImg from "../../thirdAssets/Images/customer-says-quotes.png";

const WhatCustomerSays = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const [slidesToShow, setSlidesToShow] = useState(3);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 750) {
                setSlidesToShow(1);
            }
            else if (window.innerWidth <= 1000) {
                setSlidesToShow(2);
            }
            else {
                setSlidesToShow(3);
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000
    };

    return (
        <div className="what-customer-says-main">
            <div className="what-customer-says-container">
                <ServiceHeader
                    title={selectedLanguage?.txt_testimonial}
                    heading={selectedLanguage?.txt_what_customer_says}
                    text={selectedLanguage?.txt_it_is_very_important_to_have}
                />
            </div>
            <div className="third-design-customer-says-slider-div">
                <Slider className="third-design-customer-says-slider" {...settings}>
                    {patientFeedBackData?.map((v, i) => (
                        <div className="third-design-customer-says-slider-card" key={i}>
                            <div>
                                <p>
                                    {selectedLanguage?.txt_it_is_important_to_take_happen}
                                </p>
                                <div className="customer-says-profile-div">
                                    <div className="customer-says-img-div">
                                        <img className="customer-says-img" src={v?.img} alt="" />
                                        <div className="customer-says-name-div">
                                            <h2>
                                                {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                            </h2>
                                            <h5>
                                                {isELSelect ? v?.role : (isAlSelect ? v?.alRole : v?.glRole)}
                                            </h5>
                                        </div>
                                    </div>
                                    <div>
                                        <img src={quotesImg} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default WhatCustomerSays;
